@if (!loading) {
  <nav class="navbar navbar-light bg-light navbar-expand-lg">
    <form class="form-inline flex-fill" id="formularioFiltros">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        @if (listadoAsignaciones!==ListadoAsignaciones.Manual) {
          <ul class="navbar-nav me-auto">
            <li class="nav-item ms-3">
                <div class="nav-item">
                    <input id="busquedaFormControl" type="text" class="form-control" placeholder="Buscador" [formControl]="busquedaFormControl" (input)="filtrarTabla()"/>           
                </div>
            </li>          
          </ul>
        }
    </form>
  </nav>
} 

@if (loading) {    
  <div class="spinner-container">
    <ngx-spinner name="spinnerGrafico" [ngStyle]="{'height': '400px', 'z-index':'0'}" bdOpacity=0.3bd
      Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
      <p style="color: white">C a r g a n d o . . . </p>
    </ngx-spinner>    
  </div>
} @else {
  @if (listadoAsignaciones===ListadoAsignaciones.Manual) {
    <div class="row">
      <div class="mb-3 row col-6 mt-2 ms-2">
        @if (!cargandoUsuarios) {
          <div class="col-3">
              <input id="usuarioFormControl" type="text" class="form-control" placeholder="Nombre usuario"
                  [formControl]="usuarioFormControl" 
                  [inputFormatter]="formatterUsuario"
                  [resultFormatter]="formatterUsuario" 
                  [ngbTypeahead]="searchUsuario"
                  (selectItem)="selectUsuario($event)"
                  (input)="inputUsuario()"/>
          </div>
          <div class="col-1">
              <button [disabled]="!usuarioValido" (click)="addUsuario()" type="button" class="btn btn-primary">
                Buscar
              </button>
          </div>
        } @else {
          <loading-text-spinner message="Obteniendo usuarios.." color="primary"></loading-text-spinner>
        }
      </div>
    </div>      
  }

  @if (usuariosFiltradosMultifiltro !== null) {
    @if (usuariosFiltradosMultifiltro.length === 0) {
      @if (listadoAsignaciones!==ListadoAsignaciones.Manual) {
        <ngb-alert [dismissible]="false">
          {{ messageWarning }}
        </ngb-alert>
      } @else {
        <ngb-alert [dismissible]="false">
          Debe ingresar un usuario para asignar manualmente
        </ngb-alert>
      }
    } @else {      
      <div class="altura container-fluid overflow-y-auto">
        <table class="table table-striped border">
          <thead class="text-center">
            <tr>
              <th scope="col">
                @if (listadoAsignaciones!==ListadoAsignaciones.Manual) {
                  <app-item-multifiltro 
                    [lista]="usuariosFiltrados"
                    [elementos]="usuariosMultiFiltro"
                    [nombreAtributo]="'nombresCompletos'"
                    [encabezadoColumna]="'Usuario'"
                    (elementosChange)="recargarUsuarios($event)" 
                    >
                  </app-item-multifiltro>
                } @else { Usuario }
              </th>
              <th scope="col">
                @if (listadoAsignaciones!==ListadoAsignaciones.Manual) {
                  <app-item-multifiltro 
                    [lista]="usuariosFiltrados"
                    [elementos]="rolesMultiFiltro"
                    [nombreAtributo]="'rol'"
                    [encabezadoColumna]="'Rol'"
                    (elementosChange)="recargarRoles($event)" 
                    >
                  </app-item-multifiltro>
                } @else { Rol }
              </th>
              <th scope="col">
                @if (listadoAsignaciones!==ListadoAsignaciones.Manual) {
                  <app-item-multifiltro 
                    [lista]="usuariosFiltrados"
                    [elementos]="dniMultiFiltro"
                    [nombreAtributo]="'dni'"
                    [encabezadoColumna]="'DNI'"
                    (elementosChange)="recargarDNI($event)" 
                    >
                  </app-item-multifiltro>
                } @else { DNI }
              </th>
              <th scope="col">
                @if (listadoAsignaciones!==ListadoAsignaciones.Manual) {
                  <app-item-multifiltro 
                    [lista]="usuariosFiltrados"
                    [elementos]="aeroplantasMultiFiltro"
                    [nombreAtributo]="'codigoAeroplanta'"
                    [encabezadoColumna]="'Aeroplanta'"
                    (elementosChange)="recargarAeroplantas($event)" 
                    >
                  </app-item-multifiltro>
                } @else { Aeroplanta }
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr *ngFor="let u of usuariosFiltradosMultifiltro">
              <td>{{ u.nombresCompletos }}</td>
              <td>{{ u.rol }}</td>
              <td>{{ u.dni }}</td>
              <td>{{ u.codigoAeroplanta }}</td>
              <td>
                <input
                  type="checkbox"
                  class="form-check-input"
                  (change)="toggleSeleccion(u)"
                  [checked]="seleccionados.includes(u)"
                  [disabled]="u._bloquear"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="boder bg-light p-2 d-flex justify-content-end">
        @switch (listadoAsignaciones) {
          @case (ListadoAsignaciones.Pendientes) {
            <button [disabled]="!habilitarBotones || authService.hasRole(TipoUsuario.SOPORTE)" class="btn btn-success me-2" (click)="aprobar(ListadoAsignaciones.Pendientes)">Aceptar</button>
            <button [disabled]="!habilitarBotones || authService.hasRole(TipoUsuario.SOPORTE)" class="btn btn-danger" (click)="rechazar(ListadoAsignaciones.Pendientes)">Rechazar</button>
          }
          @case (ListadoAsignaciones.Manual) {
            <button [disabled]="!usuarioValido || !habilitarBotones || authService.hasRole(TipoUsuario.SOPORTE)" (click)="aprobar(ListadoAsignaciones.Manual)" class="btn btn-success me-2">Guardar Cambios</button>
          }
          @case (ListadoAsignaciones.Asignados) {
            <button [disabled]="!habilitarBotones || authService.hasRole(TipoUsuario.SOPORTE)" (click)="rechazar(ListadoAsignaciones.Asignados)" class="btn btn-danger me-2">Restringir Acceso</button>
          }
        }
          
      </div>
    }
  }
}